import { render, staticRenderFns } from "./blindAutomaticTest.vue?vue&type=template&id=5fcedd58&scoped=true"
import script from "./blindAutomaticTest.vue?vue&type=script&lang=js"
export * from "./blindAutomaticTest.vue?vue&type=script&lang=js"
import style0 from "./blindAutomaticTest.vue?vue&type=style&index=0&id=5fcedd58&prod&scoped=true&lang=css"
import style1 from "./blindAutomaticTest.vue?vue&type=style&index=1&id=5fcedd58&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcedd58",
  null
  
)

export default component.exports